import styled from 'styled-components';
import { IStyledSelectCustomRawProps } from './interface';

interface Props extends IStyledSelectCustomRawProps {
  openOptions?: boolean;
}

export const SelectCustomContainer = styled.div<Props>`
  box-sizing: border-box;
  display: flex;
  height: ${(props) => props.height};
  position: relative;
  border-radius: ${(props) => props.borderRadius};
  width: ${(props) => props.width};
  flex: ${(props) => props.flexItem};

  input {
    flex: 1;
    max-width: ${(props) => props.width};
    padding: ${(props) => props.padding};
    font-size: ${(props) => props.fontSize};
    color: ${(props) => props.fontColor};
    font-weight: ${(props) => props.fontWeight};
    border-radius: ${(props) => props.borderRadius};
    border: ${(props) => props.border || 'none'};

    border-color: ${({ theme, ...props }) =>
      props.error ? theme.colors.attention : props.borderColor};
    cursor: pointer;
    outline: none;
    appearance: none;
    text-decoration: none;
  }
`;
export const OptionsCustomContainer = styled.div<Props>`
  animation: openOptions 0.2s ease-in-out forwards;
  display: flex;
  flex-direction: column;
  position: absolute;
  top: calc(1 * ${(props) => props.height} + 2px);
  left: 0;
  z-index: 99;

  width: ${(props) => props.widthOptionsList};
  max-height: ${(props) => props.maxHeightOptionsList};

  background-color: ${(props) => props.backgroundColorOnList};

  overflow: ${(props) => (props.openOptions ? 'hidden' : 'auto')};
  border: ${(props) => props.borderOnList};
  border-color: ${(props) => props.borderColorOnList};

  border-radius: ${(props) => props.borderRadiusOnList};

  .option {
    display: flex;
    align-items: center;
    width: 100%;
    height: fit-content;
    cursor: pointer;
    padding: 2px 8px;
    font-size: ${(props) => props.optionsFontSize};
    color: ${(props) => props.optionsFontColor};
    padding: ${(props) => props.paddingOnList};
  }
  :hover {
    background-color: ${(props) => props.hoverBackgroundColorOnList};
    color: ${(props) => props.hoverColorOnList};
  }

  @keyframes openOptions {
    0% {
      height: 0;
    }
    100% {
      height: ${(props) => props.heightOptionsList};
    }
  }
`;

export const ArrowIconContainer = styled.div<Props>`
  rotate: ${(props) => (props.openOptions ? '180deg' : '')};
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  position: absolute;
  max-width: fit-content;
  height: 100%;
  padding: 0 8px;

  left: ${(props) => (props.arrowIconPosition === 'left' ? 0 : '')};
  right: ${(props) => (props.arrowIconPosition === 'left' ? '' : 0)};

  svg {
    border-radius: 4px;
    rotate: ${(props) => (props.arrowIconPosition === 'left' ? '180deg' : '')};
    color: ${(props) => props.arrowIconColor};

    :hover {
      background-color: ${(props) => props.hoverBackgroundColor};
    }
  }
`;

export const Error = styled.div`
  position: absolute;
  margin: 0;
  line-height: 100%;
  font-size: 12px;
  color: ${({ theme }) => theme.colors.attention} !important;
  bottom: -16px;
  height: fit-content;
  left: 16px;
  height: fit-content;
`;
